import React from 'react';
import { Mic } from 'lucide-react';

/**
 * Floating Microphone Button
 * 
 * Features:
 * - Bottom right position
 * - Large, high contrast design
 * - Pulse animation when listening
 * - Senior-friendly size and colors
 * 
 * Props:
 * - onClick: Function to call when button is clicked
 * - isListening: Boolean indicating if voice recognition is active
 * - disabled: Boolean to disable the button
 */
export default function MicButton({ onClick, isListening, disabled }) {
  if (disabled) {
    return null;
  }

  return (
    <button
      onClick={onClick}
      disabled={isListening}
      className={`
        fixed bottom-24 right-8 z-40
        w-20 h-20 md:w-24 md:h-24
        rounded-full
        shadow-2xl
        flex items-center justify-center
        transition-all duration-300
        ${
          isListening
            ? 'bg-red-500 animate-pulse scale-110'
            : 'bg-blue-600 hover:bg-blue-700 hover:scale-110 active:scale-95'
        }
      `}
      aria-label={isListening ? 'Zuhören...' : 'Sprechen'}
    >
      <Mic 
        className="w-10 h-10 md:w-12 md:h-12 text-white" 
        strokeWidth={2.5}
      />
      
      {/* Pulse Ring when listening */}
      {isListening && (
        <span className="absolute inset-0 rounded-full bg-red-400 animate-ping opacity-75" />
      )}
    </button>
  );
}
